

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      if(this.form != null){

        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        
      }
      this.cartNotification = document.querySelector('cart-notification')
    }
    

    onSubmitHandler(evt) {

      evt.preventDefault()
      const submitButton = this.querySelector('[type="submit"]')
      if (submitButton.classList.contains('loading')) return

      this.handleErrorMessage()
      this.cartNotification.setActiveElement(document.activeElement)



      submitButton.setAttribute('aria-disabled', true)
      submitButton.classList.add('loading')
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => {
        return(
          section.id
        )
      }))
      formData.append('sections_url', window.location.pathname)
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        $('.upsell-product_data').html('');     
        $('#myModal').addClass('show');
      	var product_url = $(submitButton).attr('data-product_url');
        $.ajax({
        url: product_url,
        type: 'GET',
        dataType: 'html', // added data type
        success: function(res) {
         //   console.log(res);
          //  alert(res);
         var related_products =  $(res).find('.splide__track').html();
		//console.log(related_products);

          $(".upsell-product_data").html(related_products);
         // setTimeout(function(){
           slider();
         //onlyCarthtmldata();
          $.ajax({
            type: 'GET', 
            url: '/cart',
            dataType: 'html',
            success: function(cart_html) {
              var cartdrawer_content = $(cart_html).find('.cart-value').html();
              $('.cart-value').html(cartdrawer_content);
              var cart_count = $(cart_html).find('#cart-icon-bubble .brator-cart-icon.click-item-count span').html();
              $('#cart-icon-bubble .brator-cart-icon.click-item-count span').html(cart_count);
            }
          });
         // }, 1000);
        }
    });

//           if (response.status) {
//             this.handleErrorMessage(response.description)
//             return
//           }
//           this.cartNotification.renderContents(response)

//           if (response.status) {
//             this.handleErrorMessage(response.description)
//             return
//           }
//           this.cartNotification.renderContents(response)
        })

        .catch((e) => {
          console.error(e)
        })

        .finally(() => {
          submitButton.classList.remove('loading')
          submitButton.removeAttribute('aria-disabled')
          this.querySelector('.loading-overlay__spinner').classList.add('hidden')
        })
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    }

  })
}
$(document).on("click",".emi_options",function() {
console.log('clicked');
  setTimeout(function() {
 $('.product-sizes').addClass('active');
     $('.product-size-overlay').addClass('active');
     },600);
});
$(document).on("click",".product-sizes.active .close",function() {
console.log('clicked');
  setTimeout(function() {
 $('.product-sizes').removeClass('active');
     $('.product-size-overlay').removeClass('active');
   },400);
});

